import { GridLocaleText } from '@mui/x-data-grid-pro';

// ----------------------------------------------------------------

export const GRID_EE_LOCALE_TEXT: Partial<GridLocaleText> = {
  // Root
  noRowsLabel: 'Tulemusi pole',
  noResultsOverlayLabel: 'Tulemusi ei leitud.',

  // Density selector toolbar button text
  toolbarDensity: 'Tihedus',
  toolbarDensityLabel: 'Tihedus',
  toolbarDensityCompact: 'Kompaktne',
  toolbarDensityStandard: 'Standardne',
  toolbarDensityComfortable: 'Mugav',

  // Columns selector toolbar button text
  toolbarColumns: 'Veerud',
  toolbarColumnsLabel: 'Vali veerud',

  // Filters toolbar button text
  toolbarFilters: 'Filtrid',
  toolbarFiltersLabel: 'Näita filtreid',
  toolbarFiltersTooltipHide: 'Peida filtrid',
  toolbarFiltersTooltipShow: 'Näita filtreid',
  toolbarFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} aktiivset filtrit` : `${count} aktiivne filter`,

  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: 'Otsi…',
  toolbarQuickFilterLabel: 'Otsi',
  toolbarQuickFilterDeleteIconLabel: 'Puhasta',

  // Export selector toolbar button text
  toolbarExport: 'Ekspordi',
  toolbarExportLabel: 'Ekspordi',
  toolbarExportCSV: 'Laadi alla CSV-na',
  toolbarExportPrint: 'Prindi',
  toolbarExportExcel: 'Laadi alla Excelina',

  // Columns management text
  columnsManagementSearchTitle: 'Otsi',
  columnsManagementNoColumns: 'Veerud puuduvad',
  columnsManagementShowHideAllText: 'Näita/Peida kõik',
  columnsManagementReset: 'Lähtesta',
  columnsManagementDeleteIconLabel: 'Puhasta',

  // Filter panel text
  filterPanelAddFilter: 'Lisa filter',
  filterPanelRemoveAll: 'Eemalda kõik',
  filterPanelDeleteIconLabel: 'Kustuta',
  filterPanelLogicOperator: 'Loogikaoperaator',
  filterPanelOperator: 'Operaator',
  filterPanelOperatorAnd: 'Ja',
  filterPanelOperatorOr: 'Või',
  filterPanelColumn: 'Veerg',
  filterPanelInputLabel: 'Väärtus',
  filterPanelInputPlaceholder: 'Filtri väärtus',

  // Filter operators text
  filterOperatorContains: 'sisaldab',
  filterOperatorDoesNotContain: 'ei sisalda',
  filterOperatorEquals: 'võrdub',
  filterOperatorDoesNotEqual: 'ei võrdu',
  filterOperatorStartsWith: 'algab',
  filterOperatorEndsWith: 'lõpeb',
  filterOperatorIs: 'on',
  filterOperatorNot: 'ei ole',
  filterOperatorAfter: 'on pärast',
  filterOperatorOnOrAfter: 'on sel kuupäeval või hiljem',
  filterOperatorBefore: 'on enne',
  filterOperatorOnOrBefore: 'on sel kuupäeval või varem',
  filterOperatorIsEmpty: 'on tühi',
  filterOperatorIsNotEmpty: 'ei ole tühi',
  filterOperatorIsAnyOf: 'on üks järgmistest',
  'filterOperator=': '=',
  'filterOperator!=': '!=',
  'filterOperator>': '>',
  'filterOperator>=': '>=',
  'filterOperator<': '<',
  'filterOperator<=': '<=',

  // Header filter operators text
  headerFilterOperatorContains: 'Sisaldab',
  headerFilterOperatorDoesNotContain: 'Ei sisalda',
  headerFilterOperatorEquals: 'Võrdub',
  headerFilterOperatorDoesNotEqual: 'Ei võrdu',
  headerFilterOperatorStartsWith: 'Algab',
  headerFilterOperatorEndsWith: 'Lõpeb',
  headerFilterOperatorIs: 'On',
  headerFilterOperatorNot: 'Ei ole',
  headerFilterOperatorAfter: 'On pärast',
  headerFilterOperatorOnOrAfter: 'On sel või hilisemal kuupäeval',
  headerFilterOperatorBefore: 'On enne',
  headerFilterOperatorOnOrBefore: 'On sel või varasemal kuupäeval',
  headerFilterOperatorIsEmpty: 'On tühi',
  headerFilterOperatorIsNotEmpty: 'Ei ole tühi',
  headerFilterOperatorIsAnyOf: 'On üks järgmistest',
  'headerFilterOperator=': 'Võrdub',
  'headerFilterOperator!=': 'Ei võrdu',
  'headerFilterOperator>': 'Suurem kui',
  'headerFilterOperator>=': 'Suurem või võrdne',
  'headerFilterOperator<': 'Väiksem kui',
  'headerFilterOperator<=': 'Väiksem või võrdne',

  // Filter values text
  filterValueAny: 'ükskõik milline',
  filterValueTrue: 'tõene',
  filterValueFalse: 'väär',

  // Column menu text
  columnMenuLabel: 'Menüü',
  columnMenuShowColumns: 'Näita veerge',
  columnMenuManageColumns: 'Halda veerge',
  columnMenuFilter: 'Filtreeri',
  columnMenuHideColumn: 'Peida veerg',
  columnMenuUnsort: 'Tühista sortimine',
  columnMenuSortAsc: 'Sorteeri kasvavalt',
  columnMenuSortDesc: 'Sorteeri kahanevalt',

  // Column header text
  columnHeaderFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} aktiivset filtrit` : `${count} aktiivne filter`,
  columnHeaderFiltersLabel: 'Näita filtreid',
  columnHeaderSortIconLabel: 'Sorteeri',

  // Rows selected footer text
  footerRowSelected: (count) =>
    count !== 1
      ? `${count.toLocaleString()} rida valitud`
      : `${count.toLocaleString()} rida valitud`,

  // Total row amount footer text
  footerTotalRows: 'Kokku ridu:',

  // Total visible row amount footer text
  footerTotalVisibleRows: (visibleCount, totalCount) =>
    `${visibleCount.toLocaleString()} / ${totalCount.toLocaleString()}`,

  // Checkbox selection text
  checkboxSelectionHeaderName: 'Valik märkeruuduga',
  checkboxSelectionSelectAllRows: 'Vali kõik read',
  checkboxSelectionUnselectAllRows: 'Tühista kõigi ridade valik',
  checkboxSelectionSelectRow: 'Vali rida',
  checkboxSelectionUnselectRow: 'Tühista rea valik',

  // Boolean cell text
  booleanCellTrueLabel: 'jah',
  booleanCellFalseLabel: 'ei',

  // Actions cell more text
  actionsCellMore: 'rohkem',

  // Column pinning text
  pinToLeft: 'Kinnita vasakule',
  pinToRight: 'Kinnita paremale',
  unpin: 'Eemalda kinnitus',

  // Tree Data
  treeDataGroupingHeaderName: 'Grupp',
  treeDataExpand: 'näita alamelemente',
  treeDataCollapse: 'peida alamelemendid',

  // Grouping columns
  groupingColumnHeaderName: 'Grupp',
  groupColumn: (name) => `Grupeeri veeru ${name} järgi`,
  unGroupColumn: (name) => `Lõpeta grupeerimine veeru ${name} järgi`,

  // Master/detail
  detailPanelToggle: 'Detailvaate lülitus',
  expandDetailPanel: 'Laienda',
  collapseDetailPanel: 'Ahenda',

  // Used core components translation keys
  paginationRowsPerPage: 'Ridade arv lehel:',
  paginationDisplayedRows: ({ from, to, count, estimated }) => {
    if (!estimated) {
      return `${from}–${to} / ${count !== -1 ? count : `üle ${to}`}`;
    }
    const estimatedLabel = estimated && estimated > to ? `umbes ${estimated}` : `üle ${to}`;
    return `${from}–${to} / ${count !== -1 ? count : estimatedLabel}`;
  },
  paginationItemAriaLabel: (type) => {
    if (type === 'first') {
      return 'Mine esimesele lehele';
    }
    if (type === 'last') {
      return 'Mine viimasele lehele';
    }
    if (type === 'next') {
      return 'Mine järgmisele lehele';
    }
    // if (type === 'previous') {
    return 'Mine eelmisele lehele';
  },

  // Row reordering text
  rowReorderingHeaderName: 'Ridade ümberjärjestamine',

  // Aggregation
  aggregationMenuItemHeader: 'Agregeerimine',
  aggregationFunctionLabelSum: 'summa',
  aggregationFunctionLabelAvg: 'keskmine',
  aggregationFunctionLabelMin: 'min',
  aggregationFunctionLabelMax: 'max',
  aggregationFunctionLabelSize: 'suurus',
};
